import React, { useContext, useEffect, useState } from "react";
import Account from ".//..//..//..//assets//images//icons//account.svg";
import Awards from ".//..//..//..//assets//images//icons//awards.svg";
import Clients from ".//..//..//..//assets//images//icons//clients.svg";
import Items from ".//..//..//..//assets//images//icons//items.svg";
import { Link, useNavigate } from "react-router-dom";
import { ROUTES } from ".//..//..//..//constants//Routes";
import { AuthContext } from "../../../context/AuthContext";

const AdminMainPage = () => {
  const [name, setName] = useState("Róbert");

  const navigate = useNavigate();

  // check auth
  // const { authUserType } = useContext(AuthContext);
  // useEffect(() => {
  //   if (authUserType !== "admin") {
  //     navigate(ROUTES.AUTH);
  //   }
  // }, []);
  // end check auth

  return (
    <>
      <div className="px-[1rem] sm:px-[1.875rem] mt-[3rem]">
        <h2 className="font-bold font-lato text-[2rem] sm:text-[3.125rem] leading-normal">Szia, {name}!</h2>
      </div>
      <div className="px-[1.875rem] mt-[1rem] sm:mt-[3.75rem] py-10">
        <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-[2.5rem]">
          {/* Felhasznalok - Users Start*/}
          <Link to={ROUTES.ADMIN_USERS}>
            <div className="shadow-[0_16px_32px_0px_rgba(0,0,0,0.12)]  transition-bg ease-in-out duration-100 hover:bg-[#f5f8f9] cursor-pointer px-[2rem] py-[6.25rem] flex items-center justify-start flex-col rounded-xl">
              <img src={Account} alt="account icon" />
              <h2 className="text-[1.8rem] sm:text-[2.25rem] mt-[2.25rem] font-lato font-bold leading-normal">
                Felhasználók
              </h2>
              <p className="text-center mt-[1.25rem] text-[1.2rem] sm:text-[1.5rem] font-normal leading-normal">
                <span className="block">Admin felület</span>
                <span className="block">felhasználóinak</span>
                <span className="block">kezelése</span>
              </p>
            </div>
          </Link>
          {/* Felhasznalok - Users End*/}
          <Link to={ROUTES.ADMIN_ZONE_LIST}>
            <div className="shadow-[0_16px_32px_0px_rgba(0,0,0,0.12)]  transition-bg ease-in-out duration-100 hover:bg-[#f5f8f9] cursor-pointer px-[2rem] py-[6.25rem] flex items-center justify-start flex-col rounded-xl">
              <i className="bg-[rgba(6,85,103,0.5)] h-[8.5rem] w-[8.5rem] rounded-full flex justify-center items-center">
                <img src={Items} alt="items icon" />
              </i>
              <h2 className="text-[1.8rem] sm:text-[2.25rem] mt-[2.25rem] font-lato font-bold leading-normal">
                Tételek
              </h2>
              <p className="text-center mt-[1.25rem] text-[1.2rem] sm:text-[1.5rem] font-normal leading-normal">
                <span className="block">Kalkulátorhoz</span>
                <span className="block">rendelt tételek </span>
                <span className="block">kezelése</span>
              </p>
            </div>
          </Link>
          <Link to={ROUTES.ADMIN_AWARDS}>
            <div className="shadow-[0_16px_32px_0px_rgba(0,0,0,0.12)]  transition-bg ease-in-out duration-100 hover:bg-[#f5f8f9] cursor-pointer px-[2rem] py-[6.25rem] flex items-center justify-start flex-col rounded-xl">
              <img src={Awards} alt="awards icon" />
              <h2 className="text-[1.8rem] sm:text-[2.25rem] mt-[2.25rem] font-lato font-bold leading-normal">Díjak</h2>
              <p className="text-center mt-[1.25rem] text-[1.2rem] sm:text-[1.5rem] font-normal leading-normal">
                <span className="block">Kalkulátorban</span>
                <span className="block">használt árak</span>
                <span className="block">megszabása</span>
              </p>
            </div>
          </Link>
          <Link to={ROUTES.ADMIN_CLIENTS}>
            <div className="shadow-[0_16px_32px_0px_rgba(0,0,0,0.12)]  transition-bg ease-in-out duration-100 hover:bg-[#f5f8f9] cursor-pointer px-[2rem] py-[6.25rem] flex items-center justify-start flex-col rounded-xl">
              <img src={Clients} alt="clients icon" />
              <h2 className="text-[1.8rem] sm:text-[2.25rem] mt-[2.25rem] font-lato font-bold leading-normal">
                Ügyfelek
              </h2>
              <p className="text-center mt-[1.25rem] text-[1.2rem] sm:text-[1.5rem] font-normal leading-normal">
                <span className="block mb-[4.5rem]">Ügyféllista kezelése</span>
              </p>
            </div>
          </Link>
        </div>
      </div>
    </>
  );
};

export default AdminMainPage;
